/**
 * Cloud Analytics Platform Export Options
 *
 * Snowflake, AWS, Azure, Google Cloud, and NorthGravity configurations
 */

import type { ExportOptionGroup } from '@/features/DataHub/modules/Export/types/exportConfig.types';

import {
  AwsIcon,
  AzureIcon,
  CloudOutlined,
  GoogleCloudIcon,
  NorthGravityIcon,
  SnowflakeIcon
} from './icons';
import { integrationButtons, integrationPreview } from './previewConfigs';

export const cloudPlatformsGroup: ExportOptionGroup = {
  groupName: 'Cloud analytics platforms',
  GroupIcon: CloudOutlined,
  options: [
    {
      id: 'snowflake',
      icon: { url: SnowflakeIcon, size: 20 },
      disabled: false,
      buttonLabel: 'Enable Access',
      actionHeading: 'GX Data in Snowflake',
      bulletPoints: [
        'Data available immediately through private share',
        'GX tables added to your Snowflake catalogue',
        'Available for all cloud providers in all regions'
      ],

      buttons: [
        {
          label: 'Enable Access',
          action: 'export'
        },
        {
          label: 'Copy to clipboard',
          action: 'copy'
        }
      ],
      preview: {
        type: 'sql',
        language: 'sql'
      }
    },
    {
      id: 'aws',
      label: 'Amazon Web Services',
      icon: { url: AwsIcon, size: 12 },
      buttonLabel: 'Enable Access',
      disabled: false,
      actionHeading: 'GX Data in AWS',
      bulletPoints: [
        'Data immediately available: No ETL',
        'Tables with full metadata and history',
        'Available as S3 share'
      ],
      buttons: integrationButtons,
      preview: integrationPreview
    },
    {
      id: 'google_cloud',
      icon: { url: GoogleCloudIcon, size: 20 },
      buttonLabel: 'Enable Access',
      disabled: false,
      actionHeading: 'GX Data in Google Cloud',
      bulletPoints: [
        'Data immediately available: No ETL',
        'Tables with full metadata',
        'Available via Google Cloud Storage'
      ],
      buttons: integrationButtons,
      preview: integrationPreview
    },
    {
      id: 'azure',
      icon: { url: AzureIcon, size: 20 },
      buttonLabel: 'Enable Access',
      disabled: false,
      actionHeading: 'GX Data in Azure',
      bulletPoints: [
        'Data immediately available: No ETL',
        'Tables with full metadata',
        'Blob storage via Azure Data Share'
      ],

      buttons: integrationButtons,
      preview: integrationPreview
    },
    {
      id: 'north_gravity',
      icon: { url: NorthGravityIcon, size: 20 },
      buttonLabel: 'Enable Access',
      label: 'NorthGravity',
      disabled: false,
      actionHeading: 'GX Data in NorthGravity',
      bulletPoints: [
        'Data immediately available: No ETL',
        'History, metadata, holiday calendars available',
        'Timeseries available in data preps and elsewhere'
      ],

      buttons: integrationButtons,
      preview: integrationPreview
    }
  ]
};
